export const cnTraditional = {
  gog: '賭神賽',
  stayTuned: '第二彈 7 月｜7/1 · 7/2 · 7/8 北京時間晚上 10 點',
  introduction: '比賽簡介',
  award: '獎金',
  details: '比賽詳情',
  faq: '常見問題',
  new: '新',
  topMaster: '賭神榜',
  backToTop: '返回頁頂',
  introductionDetails: 'CHOICE 賭神賽今年以「系列賽事」全新升級' +
  '\n' +
  '\n' +
  '自 6 月正式開戰，每月推出多場比賽，連續舉辦至 12 月年終收官，' +
  '全年共 7 場賽事獨立舉行、獎金每場賽後立即派發。' +
  '\n' +
  '\n' +
  '單場冠軍最高可獨享 CNY 100 萬現金獎勵，全年七場累計總獎金高達 CNY 1,500 萬，' +
  '\n' +
  '\n' +
  '月月開賽，場場精彩，賭神之巔等你登頂！',
  introductionDetailsMobile: 'CHOICE 賭神賽今年以「系列賽事」全新升級' +
  '\n' +
  '\n' +
  '自 6 月正式開戰，每月推出多場比賽，連續舉辦至 12 月年終收官，' +
  '全年共 7 場賽事獨立舉行、獎金每場賽後立即派發。' +
  '\n' +
  '\n' +
  '單場冠軍最高可獨享 CNY 100 萬現金獎勵，全年七場累計總獎金高達 CNY 1,500 萬，' +
  '\n' +
  '\n' +
  '月月開賽，場場精彩，賭神之巔等你登頂！',
  howToEnter: '如何參加',
  gameProcess: '比賽流程',
  step: '步驟',
  step1: '用戶賬號必須為\n本平台的真錢賬號',
  step2: '進入本平台\n在 “賭神賽” 廳中選擇\n對應的比賽場報名即可',
  howToJoin1: '用戶賬號必須為本平台的真錢賬號',
  howToJoin2: '進入本平台在“賭神賽”廳中選擇對應的比賽場報名即可',
  satelliteTournament: '採用人滿開賽的方式，資格賽獲勝玩家將獲得賭神賽門票，於賭神賽贏取更豐富獎金。',
  masterTournament: '採用定時開賽的方式，讓更多玩家都能參與到比賽中來，同時賭神賽的巨額獎金使比賽競爭更激烈，比賽氣氛更緊張刺激。',
  seasonTournament: '採用定時開賽方式，邀請當季賭神參賽，與通過足額積分報名的玩家進行高手同場競技，冠軍將獲得超高額獎金！',
  awardDetails: '所有用戶在所參與的比賽場中所獲得的獎金會即時到賬用戶所在的本平台遊戲戶口，無需等待，無需審核。',
  qualifyingRound: '資格賽',
  qualRoundText: '採用人滿開賽的方式，資格賽\n獲勝玩家獲得賭神賽門票，\n於賭神賽贏取更豐富獎金',
  gogTickets: '賭神賽門票 /\n足額積分',
  gogMasterTournament: '賭神賽',
  gogStep3: '採用定時開賽的方式，讓更多\n玩家都能參與到比賽中來。\n同時賭神賽的巨額獎金使比賽\n競爭更激烈，氣氛更緊張刺激。',
  tournamentRules: '比賽規則',
  fairness: '公平性',
  regAndWithdrawal: '報名及退賽',
  inGame: '玩法規則',
  ranking: '排名規則',
  withdraw3: '報名後退賽（未滿足所需人員時）且比賽尚未開始',
  withdraw3Child: '玩家可以立即退出，3分鐘內玩家不能再次報名同類型賽事，系統將退還扣除的積分/門票。',
  withdraw4: '報名後退賽（達到報名人數）且比賽尚未開始：',
  withdraw4Child: '參賽者必須進入比賽方可退出，該參賽者將被系統視為淘汰。 所有扣除的用戶積分或門票將不予退還。',
  withdraw5: '參賽者決定在比賽期間退賽',
  withdraw5Child: '比賽期間，若任何參賽者選擇另一場比賽或退出比賽，則根據有效投注數和參賽輪數來決定排名和獲勝機會。',
  withdraw6: '玩家退出該場比賽後將無法重新參與同一場比賽。',
  withdraw7: '每位玩家在同一天內只能退出已報名的比賽最多5次，如果超過5次則不允許玩家報名同一類型的比賽。',
  tournamentRules1: '玩家報名參加比賽後，在比賽中將以固定的比賽籌碼在特定的比賽桌枱中進行投注，該比賽籌碼與玩家個人真錢額度及 用戶積分並無任何關聯，所有比賽籌碼將不會累積帶到下一個比賽場中。若玩家的用戶積分不足，可通過非比賽的遊戲投注，來提高有效投注額換積分。',
  tournamentRules2: '為保證系統公平透明性，玩家報名成功後，進入比賽場時的座位均採用系統隨機分配，玩家不得選擇或交換桌台上的座位。',
  tournamentRules3: '所有比賽獎金將依照各比賽場獎金分配表發放，實時到賬。',
  tournamentRules4: '比賽將根據“免佣百家樂”的規則下進行，有關“百家樂”遊戲規則請於遊戲內按菜單>遊戲規則查看玩法。參賽者必須於每局下注時間內下注，每局的下注時限為25 秒，每位參賽者必須於每局至少以最低投注額下注於莊家或閒家。於每一手牌中，參賽者只可選擇投注於莊家或閒家任何一方，當選擇投注於和局或對子時，亦必須同時選擇投注莊家或閒家其中一方。',
  tournamentRules5Part1: '於資格賽及賭神賽開始前，每位參賽者將獲得比賽籌碼10萬（比賽籌碼只適用於比賽，不能兌換現金或現金籌碼），玩家在比賽中的投注限紅為1,000 -100,000，參賽者不可投注多於其擁有之比賽籌碼。',
  tournamentRules5Part2: '在比賽進行時，參賽者於每局的投注金額限制如下：',
  betItem: '投注項目',
  minBet: '最低投注籌碼',
  maxBet: '最高投注籌碼',
  banker: '莊家',
  player: '閒家',
  tie: '和局',
  pair: '對子',
  tournamentRules6: '所有比賽場，荷官會先派出2局不設投注的牌局後開始正式發牌，後面的比賽在同一靴牌中將不再重複洗牌。',
  tournamentRules7: '為保證玩家間的公平透明，比賽系統將使用以下晉級/淘汰機制：',
  tournamentRules7_1: '比賽過程中,系統根據每場比賽場次設定的規則每輪按虛擬桌晉級指定數目的玩家，每輪未獲晉級的參賽者將自動淘汰。',
  tournamentRules7_2: '例如：某場比賽共56人參賽，玩家分布於“A、B、C、D、E、F、G 、H”8個虛擬桌上，比賽共分4輪(每輪5局)進行，每輪比賽每桌晉級前3名, 即A-H每桌的前3名晉級下一輪(未晉級的自動淘汰),直到比賽完成。',
  tournamentRules7_3: '玩家比賽中晉級的額度優勢：如比賽場設定每桌每輪晉級2 人以上時，當玩家在上一輪以第一名晉級下一輪時，每桌第一名的玩家的在下一輪的初始比賽籌碼額度會有固定百分比的增加（即每桌的第一名會比其他玩家多固定百分比的比賽籌碼額度，該百分比在游戲中設定）。',
  tournamentRules7_4: '系統採用盡量保證每桌玩家數目平均的方式，每輪晉級的玩家將會再次隨機平均分配到不同的桌上進行遊戲。',
  tournamentRules8: '於比賽過程中，可使用的特別投注功能條款如下:',
  tournamentRules8_1: '“暗注”供參賽者於比賽中使用，是屬於策略投注技巧。主要是隱藏自己投注的項目，直到投注時間完畢時，其他玩家才能看到自己所投的籌碼及位置。暗注次數則按該場比賽的”輪數”提供相對的暗注次數。例如：總輪數：5 , 總暗注次數：5',
  tournamentRules8_2: '“過牌”供參賽者做決定時使用，意思就是不下注。過牌次數則按該場比賽的”輪數”提供相對的過牌次數。例如：總輪數：5 , 總過牌次數：5',
  tournamentRules9: '不論贏或輸，所有已使用或未使用的特別投注功能於比賽結束時將自動清零，參賽者之間不能轉讓或借用比賽籌碼，在每場比賽結束後，系統會將玩家的比賽籌碼自動清零。',
  tournamentRules10: '排名規則將使用以下優先級：',
  tournamentRules10_1: '晉級玩家排名高於淘汰玩家,然後按該場比賽籌碼從高至低來排名。',
  tournamentRules10_2: '若玩家比賽籌碼相同,則該場勝率較高者排名較高。',
  tournamentRules10_3: '若以上2个排名規則情况下多個參賽者存在相同排名,則以該場報名時間較早的玩家排名較高。',
  tournamentRules11: '如參賽者在比賽中因任何理由需離開比賽，離桌的時間不可超過5局遊戲，若違反此規定，参賽者獲獎的資格將被取消而只可獲排名。',
  tc: '活動條款',
  tc1: '所有有效本平台真錢會員均可參加。',
  tc2: '活動期間，玩家參與“資格賽”，需使用玩家現有用戶積分報名參與賽事。',
  tc3: '所有比賽均依照比賽大廳所公告之時間准時開始報名，我們有權在不事先通知玩家的情況下，更改、延遲或取消比賽。',
  tc4: '用戶積分可透過在本平台內進行有效投注獲得，適用遊戲包括：百家樂、龍虎、骰寶、輪盤、二十一點、炸金花、BID、MultiPlay、VIP 以及 Good Road。詳細說明以及積分兌換規則，請參考平台內的「用戶積分系統」說明。',
  tc5: '“資格賽”勝出者即可獲取參與“賭神賽”門票一張（若門票已派完，則當日不再發放門票，所有比賽也不再接受報名。先到先得，派完即止）。每位玩家獲得的門票僅於本週比賽活動期間有效。',
  tc6: '為保證活動回饋廣大會員，本活動每位會員限同一帳戶及同一IP地址參加。違規者取消領獎資格，嚴重舞弊者本平台有權在不事先通知情況下作封號處理或扣除相關獲利。',
  tc7: '任何會員以任何非法手段，包括但不限於對衝、合謀作弊等參加本活動，違規處理等同活動條款 6。',
  tc8: '若違反比賽之規定，參賽者將會失去其參賽的資格;',
  tc9: '玩家參加本次活動，即視為同意本活動條款。',
  tc10: '本平台保留對本次活動的最終解釋權。',
  remark: '注意事項',
  registration: '報名',
  registration1: '如果玩家同時擁有賭神賽門票和足夠積分的情況報名賭神賽, 玩家可選擇使用積分或賭神賽門票參賽。',
  registration2: '任何比賽開始前的180分鐘內同一用戶同時只能報名一場比賽（資格賽或賭神賽）',
  registration2_1: '為確保玩家能優先進行賭神賽，當玩家已經報名賭神賽且距離下場賭神賽開始只有180分鐘的情況下，同一個玩家不能報名另一場資格賽。',
  registration2_2: '若玩家已報名賭神賽且離該賭神賽開始多於180分鐘，則玩家仍可以報名資格賽，但當該場賭神賽開始只有180分鐘且玩家報名的資格賽仍未開始則系統會自動取消玩家所報名的資格賽並退回積分。',
  cancelReg: '退賽',
  cancelReg1: '每一位玩家只可以在比賽开始前退赛，退赛后3分鐘內将不可以重新报名该相同场次的比賽, 系統會退回所扣積分或門票。',
  cancelReg2: '比賽開始後,玩家強行退賽將按該玩家已下注局數及輪數來判斷排名及獲獎機會。',
  watch: '旁觀',
  watch1: '所有用戶可以選擇旁觀正在進行中的比賽, 不能投注比賽, 但可以進行聊天。',
  exception: '異常處理',
  exception1: '如遇系統故障原因而影響比賽順利進行,我們有權隨時取消比賽，並且將該場比賽取消後實時退還玩家在該場比賽已扣除的用戶積分或賭神賽門票。',
  exception2: '比賽開始後，因玩家自身網絡原因造成的斷線，玩家應在5局時間內重新登錄並即時返回該比賽場遊戲，自動下注系統將在每一局以最小限紅於“閒”下注，當5局時間內玩家仍未進入比賽場將自動因玩家沒有任何手動下注而被淘汰，玩家只會獲取排名而不會獲取任何獎金機會。',
  exception3: '任何參與比賽的玩家如因連續使用對衝下注等方法進行比賽投注，我們有權取消玩家比賽資格及獎金，並將對該玩家作封號處理，永久不得參加比賽。',
  q1: '如何參加季度賽？',
  faq1: '如何參加季度賽：季度賽門票一張，或積分報名。\n如何獲得季度賽門票：當季度的任何一場賭神賽冠軍可獲得季度賽門票一張，門票在季度賽開始前派發。季度賽門票僅限當期季度賽使用，過期無效。',
  q2: '比賽大廳在哪？',
  faq2: '成功登錄本平台的PC版後，在左側導航欄按下賭神賽，便可進入比賽大廳。如未顯示，請與您的運營商或客服聯系。手機網頁版的比賽大廳在 本平台遊戲大廳中有一個獨立的入口按鈕。',
  q3: '如何報名比賽？',
  faq3: '進入比賽大廳後，選擇您想要参加的比賽場次，按報名鍵即可；手機版本請點擊本平台賭神賽大廳的“報名”鍵進入。',
  q4: '參賽資格是甚麼？',
  faq4: '您必須擁有一個個人的本平台真錢帳號，個人帳戶必須有足夠積分或門票來參與資格賽或賭神賽。',
  q5: '如何兌換積分？',
  faq5: '100人民幣有效投注額 = 1積分或到用戶積分专页查看更多详情\n如:\nA玩家有效投注額為10000，則A用戶積分為100積分；\nB玩家有效投注額為8650,則B玩家的積分為 86積分；\n積分將不會產生小數位，只取整數。',
  q6: '在哪查詢我有多少積分？',
  faq6: '您可以按下大廳個人頭像旁的 (i)，即可顯示個人信息，其中包括用戶積分：\n或於比賽大廳左上角的用戶積分位置查看：',
  q7: '怎樣賺取更多積分？',
  faq7: '用戶積分是通過玩家在本平台的有效投注額兌換獲得，積分不限時間、不清零，只有在本平台視訊遊戲投注的有效投注額才可兌換，視訊遊戲包括：各類型百家樂、龍虎、骰寶、輪盤、21點、牛牛、炸金花、競咪、多台、包桌及好路下注。\n\n請注意： 小費、送禮物給主播、非視訊類遊戲中的有效投注等，一律不包括在賺取積分內',
  q8: '怎樣才算有效投注？',
  faq8: '有效投注: 指所有產生輸贏的投注。\n無效投注: 指玩家在同一局遊戲同時投注輸贏兩種結果。\n例：在百家樂遊戲同一局內，同時下注莊、閒的對沖投注。',
  q9: '資格賽和賭神賽有甚麼區別？',
  faq9: '資格賽: 採用人滿開賽的方式，資格賽獲勝玩家將獲得賭神賽門票，於賭神賽贏取更豐富獎金。\n賭神賽：採用定時開賽的方式，讓更多玩家都能參與到比賽中來，同時賭神賽的巨額獎金使比賽競爭更激烈，比賽氣氛更緊張刺激。',
  q10: '報名費是多少？',
  faq10: '活動期間玩家無需任何報名及手續費用，只需使用用戶積分或賭神賽門票進行報名。',
  q11: '賭神賽門票如何獲得？',
  faq11: '在同一天內，只要您有足夠的用戶積分，便可無限次報名資格賽。資格賽獲勝玩家將獲得賭神賽門票，憑此門票可參加於活動期間舉辦的任何賭神賽場次。\n注意：每一玩家擁有的賭神賽門票數量上限為10張，獲得的門票可於活動期間用於報名的賭神賽，報名一場賭神賽即立刻扣除玩家一張門票。賭神賽門票只於賭神賽本月比賽活動期間有效，活動結束後即失效，本平台不作任何退款及退積分。',
  q12: '能否直接使用用戶積分兌換賭神賽門票參賽？',
  faq12: '可以，如果您沒有賭神賽門票但擁有很多的用戶積分情況下，您可直接在賭神賽按報名鍵，系統會直接扣除所需積分。\n請注意：資格賽只可使用用戶積分進行報名',
  q13: '可以選擇扣除門票或積分嗎？',
  faq13: '資格賽報名時, 只扣除玩家的用戶積分；賭神賽報名時，則可選擇使用積分或賭神賽門票參賽。',
  q14: '試玩帳號能否報名？',
  faq14: '活動期間所有比賽場只開放給本平台真錢賬號報名，試玩賬號的玩家只限進入任何比賽進行旁觀。',
  q15: '為甚麼提示報名失敗？',
  faq15: '報名失敗有以下幾種原因：\n您的賬戶不是真錢帳戶或沒有符合參賽要求；\n您已報名並選擇退賽，於3分鐘內您將不允許再次報名同一比賽場次。',
  q16: '報名後能否退賽？',
  faq16: '報名後(人數未滿時)及比賽未開始：\n允許玩家即時退賽，但3分鐘內不能再次報名同類型的比賽，系統會退回所扣積分或門票。\n報名後(人數已達到要求)及比賽未開始：\n允許玩家進入比賽後才能退賽，系統將判斷玩家為自動棄權，因玩家主動退賽，系統不會退回因報名已扣除的積分或門票。\n比賽中玩家主動退賽：\n玩家在比賽中主动点”返回”来退赛，系统将判断玩家已下注的局数及轮数来判断玩家的排名及获奖机会，另外因玩家主动退赛，系统不会退回因报名已扣除的积分或门票。\n請注意：\n1. 同一玩家報名一場比賽後選擇退賽，將不可重新報名同一場次的比賽；\n2. 每名玩家同一天內最多只可退賽5次，若超過5次則不允許報名同類型比賽。',
  q17: '報名後，是否須在比賽大廳等待開賽？',
  faq17: '無須在比賽大廳等待開賽，玩家可以先進入其他遊戲下注，直到人滿比賽開始前或是臨近開賽時間時，系統將會發出提示信息通知玩家準備進入比賽。',
  q18: '每場比賽需時多久？',
  faq18: '每一場比賽大概5至20分鐘。',
  q19: '比賽是否使用個人真錢額度投注？',
  faq19: '在比賽場下注時，所有參賽者都只能使用系統提供的比賽籌碼投注，與玩家本身的真錢額度沒有直接關係。',
  q20: '比賽籌碼是甚麼？',
  faq20: 'CHOICE賭神賽秉承公平、公正、透明的原則，比賽場中所有玩家進入比賽時都擁有相同的初始籌碼，即稱為比賽籌碼。比賽籌碼為CHOICE賭神賽系統中專用的額度，與玩家本身的真錢額度沒有直接關系，比賽籌碼的多少將作為比賽排名的決定因素。比賽籌碼不能轉入及轉出，只可用於當場比賽，每場比賽結束後，參賽者的比賽籌碼即被清零。',
  q21: '旁觀可以投注嗎？',
  faq21: '只有報名參賽的玩家才可於比賽場內進行投注，旁觀的玩家不可進行投注，只可進行旁觀。如須參賽，可在比賽大廳按“報名參賽”鍵，選擇比賽場進行報名。',
  q22: '比賽中的在線人數是什麼？',
  faq22: '代表已報名該場比賽的總人數。',
  q23: '各投注區的限紅是多少？',
  betLimit: '限紅',
  bankerPair: '莊對子',
  playerPair: '閒對子',
  q24: '為何無法投注“對子”及“和”？',
  faq24: '參賽者必須投注莊或閒家其中一方，才可投注“對子”及“和”。',
  q25: '甚麼是“暗注”？',
  faq25: '玩家先按下“暗注”鍵，再進行投注，將會隱藏玩家投注的項目和金額，直到開牌時，其他玩家才能看到玩家所投的籌碼，屬於一種策略投注技巧。',
  q26: '甚麼是“過牌”？',
  faq26: '玩家按下“過牌”後，該局可不進行任何投注，系統也不會自動扣除最小限紅的投注額。',
  q27: '過牌及暗注次數是否能累計？',
  faq27: '所有已使用或未使用的過牌及暗注次數只於該場比賽內有效，該場比賽結束後即失效，無法累計到下一場使用。',
  q28: '於賭神賽中，如何決定晉級或淘汰？',
  faq28: '為保證比賽的公平透明， 賭神賽 系統將使用以下晉級及淘汰機制：\n比賽過程中，每輪比賽每張虛擬桌晉級固定數目的玩家，每輪未獲晉級的玩家將自動淘汰。例如：某場比賽共56人參賽，玩家分佈於A、B、C、D、E、F、G 、H 八個虛擬桌上，比賽共分4輪(每輪5局)進行，每輪比賽每桌晉級前3名, 即A-H每桌的前3名晉級下一輪(未晉級的自動淘汰),直到比賽完成。\n',
  q29: '如何決定玩家排名？',
  faq29: '排名規則將使用以下優先順序：\n晉級玩家排名高於淘汰玩家，然後按該場比賽籌碼從高至低來排名；\n若玩家比賽籌碼相同,則該場勝率較高者排名較高；\n若以上2個排名規則情況下多個玩家存在相同排名,則以該場報名時間較早的玩家排名較高。',
  q30: '獎品或獎金如何分配？',
  faq30: '請於該比賽場按“查看詳情”鍵查詢有關資訊。',
  q31: '怎樣領取在比賽中獲得的獎金？',
  faq31: '在比賽中所有獲得的獎金經審核後將即時存入玩家帳戶內。',
  q32: '為甚麼賭神賽中下一輪開始時其他人的比賽籌碼比我高？',
  faq32: '所有參賽者於賭神賽晉級後，直到該場比賽完結。為了保持玩家與玩家的良性競爭，每桌第一名的玩家在下一輪的初始比賽籌碼額度會有固定百分比的增加。',
  q33: '如比賽取消已扣除的積分或賭神賽門票是否會退回？',
  faq33: '如比賽取消，所有已扣除的積分或門票都會即時退回到您的真錢帳號內，無需扣除任何手續費。',
  q34: '比賽投注紀錄在哪查詢？',
  faq34: '參賽者可在比賽大廳按“客戶服務” > “帳戶紀錄” > 於左側選擇“比賽下注紀錄”內查詢。',
  q35: '賭神榜是什麼?',
  faq35: '賭神榜是紀錄每一場賭神賽獲得第1名的賭神名稱及獲得的獎金金額，按下排名中玩家的名字可查看該玩家於賭神賽中獲得獎金的金額及場次詳情。',
  q36: '賭神賽進行過程中，我的網絡掉線了怎麼辦？',
  faq36: '若玩家因網路掉線，系統將自動在5局內以最少注於“閒”下注，5局內未返回比賽場則當作淘汰處理。系統會根據玩家曾經下注的局數及輪數來判斷玩家排名位置及獲獎機會。',
  topMasterCongrats: '恭喜以下玩家於賭神賽奪獎',
  tournamentSetting: '賽事設置',
  choiceDirect: 'CHOICE直邀',
  others: '其他',
  choice: 'CHOICE直邀',
  qChoice1: '什麼是CHOICE直邀',
  faqChoice1: '「CHOICE直邀」標籤專屬於歷史有效總下注額達千萬人民幣以上之玩家',
  regQ3Faq: '比賽期間，所有本平台真錢賬戶無需支付任何註冊費和手續費。 當玩家想要報名參加賭神賽時，其賬戶中需要有足夠的積分或賭神賽門票。',
  copyright: '版權所有',
  playerName: '即將揭曉',
  amountTbd: 'CNY 待定'
};
